<template>
  <div class="counterpart_list">
    <div class="response_table">
      <div v-if="loading">
        <div class="spinner">
          <scale-loader />
        </div>
      </div>

      <table v-else>
        <thead>
          <tr>
            <th scope="col"> {{ translate('diadoc.counterparties.name') }} </th>
            <th scope="col"> {{ translate('diadoc.counterparties.full_name') }} </th>
            <th scope="col"> {{ translate('diadoc.counterparties.inn') }} </th>
            <th scope="col"> {{ translate('diadoc.counterparties.kpp') }} </th>
          </tr>
        </thead>
        <tbody>
            <tr
                class="counterpart_item"
                v-for="(counterpart,key) in counterparties"
                :key="key"
            >
              <td class="text-left" :data-label="translate('diadoc.counterparties.name')"> {{ counterpart.name }} </td>
              <td class="text-left" :data-label="translate('diadoc.counterparties.full_name')"> {{ counterpart.full_name }} </td>
              <td class="text-left" :data-label="translate('diadoc.counterparties.inn')"> {{ counterpart.inn }} </td>
              <td :data-label="translate('diadoc.counterparties.kpp')"> {{ counterpart.kpp }}</td>
            </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

export default {
  name: 'DiadocСounterparties',
  components: {
  },
  data () {
    return {
      counterparties: [],
      loading: false,
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true,
    }
  },

  created () {
    this.get_diadoc_counterpart_list()
  },

  watch:{

  },

  computed:{

  },

  methods: {
    get_diadoc_counterpart_list(){
      this.loading = true
      this.$http.v1.getDiadocCounterpartList((response) => {
        this.counterparties = response.data
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .counterpart_list {
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;

    .response_table{
      //padding: 10px 0 0;
      padding: 0;
      tbody{
        tr{
          font-size: 12px;
          &:hover{
            background-color: #eeeeee;
          }
        }
        .text-left{
          text-align: left;
        }

        .limit{
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          text-overflow: ellipsis;
          line-height: 1.5em;
          max-height: 3em;
          margin-bottom: 0;
          font-size: 12px;
        }
      }
    }
  }
</style>
